import controller from './organization-alerts.controller';

const template = require('./organization-alerts.html');

export default {
    controller,
    template
};
